/* import __COLOCATED_TEMPLATE__ from './bottom-banner.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */

import templateOnlyComponent from '@ember/component/template-only';
import type Banner from 'embercom/models/banners/banner';
import type LocalizedBannerContent from 'embercom/models/banners/localized-banner-content';

interface Args {
  banner: Banner;
  localizedBannerContent: LocalizedBannerContent;
  isEditing?: boolean;
  /** When true, renders banner preview with dark theme contrast checking */
  isDarkTheme?: boolean;
}

interface Signature {
  Args: Args;
}

const BottomBanner = templateOnlyComponent<Signature>();
export default BottomBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::Editor::Content::WebChrome::BottomBanner': typeof BottomBanner;
    'banners/editor/content/web-chrome/bottom-banner': typeof BottomBanner;
  }
}
